module.exports = __webpack_public_path__ + "media/images/icons/outlined/video-camera-b436c90fb476ac8e6d3b5a870a0b913b.svg";